<template>
    <div class="cdjj-wrapper" v-loading="loading">
        <div class="cdjj-header">
            <div>
                <el-button @click="goback()" class="goback" size="mini">
                <i class="el-icon-d-arrow-left"></i>返回
                </el-button>
                <h2>已报名单<span><strong>*</strong>如发现学生信息有误，请到"学生管理"中进行修改</span></h2>
            </div>
            <div class="btn">
                <div class="ipt">
                    <el-input
                        v-model="tableIpt.mobile"
                        @keyup.enter.native="searchList()"
                        placeholder="请输入学号/姓名/身份证号/手机号"
                        style="width: 250px;"
                    ></el-input>
                </div>
                <el-button plain @click="searchList()" style="margin-right:10px;">查 询</el-button>
                <el-button
                    plain
                    @click="cancelApply()"
                    v-if="$_has('zledu.jiaoxue.examination.cancelApply')"
                >取消报名</el-button>
                <el-button
                    plain
                    @click="exportList()"
                    v-if="$_has('zledu.jiaoxue.examination.export')"
                    :disabled="isCanExport"
                >导出</el-button>
            </div>
        </div>
        <div class="cdjj-table" :style="'padding-bottom:'+(tableData.length?'0':'16')+'px'">
            <el-table
                :data="tableData"
                style="width: 100%"
                :height="tableData.length?windowHeight-215:windowHeight-175"
                :header-cell-style="headerCellStyle"
                class="collegeTable"
                :cell-style="cellStyle"
                :empty-text="empty"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" width="55" label="序号">
                    <template slot-scope="scope">
                        <span>{{(pageTotal.currentPage - 1) * pageTotal.pageSize + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="studentNumber" label="学号"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="idCard" label="身份证号" width="155">
                    <template slot-scope="scope">
                        <span>{{scope.row.idCard | desensitizationText}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="schoolDate" label="入学年份"></el-table-column>
                <el-table-column prop="mobile" label="手机号">
                  <template slot-scope="scope">
                    <span style="color: #333333">{{scope.row.mobile | desensitizationText}}</span>
                  </template>
                </el-table-column>
            </el-table>
            <Pagination
              :currentpage="pageTotal.currentPage"
              :limit="pageTotal.pageSize"
              :total="pageTotal.total"
              layout="sizes, prev, pager, next, jumper"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
              :small="true"
              v-if="tableData.length"
            ></Pagination>
        </div>
    </div>
</template>
<script>
import Pagination from "../../../paginator/paginator";
import * as api from "../../../../api/educationalApi"
import axios from 'axios'
import {desensitization} from "@/utils/utils";
export default {
    filters:{
      desensitizationText(val){
        return desensitization(val) || '——'
      }
    },
    components: {
        Pagination
    },
    data() {
        return {
            tableIpt: {
                name: "",
                studentNumber: "",
                mobile: ""
            },
            tableData: [],
            windowHeight: window.innerHeight,
            height: window.innerHeight - 215 + "px", // 表格高度根据窗口高度来决定
            empty: "暂无数据",
            pageTotal: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
            loading: true,
            multipleSelection: [],
            isCanExport: false,
        };
    },
    created() {
        this.getStudentList();
    },
    methods: {
        // 学生管理列表
        getStudentList() {
            let fd = {
                name: this.tableIpt.mobile,
                page: this.pageTotal.currentPage,
                limit: this.pageTotal.pageSize
            };
            api.joinExamStudent(fd).then(res => {
                if (res.code == 0) {
                    let listArr = res.data;
                    this.tableData = listArr.list;
                    this.isCanExport = this.tableData.length === 0 ? true : false;
                    if (
                        this.tableData.length &&
                        listArr.total > this.pageTotal.pageSize
                    ) {
                        this.height = window.innerHeight - 215 + "px";
                    } else {
                        this.height = window.innerHeight - 170 + "px";
                    }
                    this.pageTotal.total = listArr.total;
                } else {
                    this.$messageError(res.msg);
                    return;
                }
                this.loading = false;
            }).catch(error => {
                console.log(error);
            });
        },
        // 查询学生管理列表
        searchList() {
            this.loading = true;
            this.pageTotal.currentPage = 1;
            this.getStudentList();
        },
        // 取消报名
        cancelApply() {
            if (this.multipleSelection.length === 0) {
                this.$message({message: "请选择取消报名的学生！",type: "warning"});
                return;
            }
            let arr = [];
            this.multipleSelection.forEach(item => {
                arr.push(item.userId);
            });
            let params = arr.join(',');
            this.$confirm('确定取消该组学生考试报名吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                  api.cancelExam({
                    jes: params
                  }).then(res => {
                      if (res.code === "0") {
                          this.$message({
                              message: "取消成功！",
                              type: "success"
                          });
                          this.searchList();
                      } else {
                        this.$messageError(res.msg)
                      }
                  }).catch((err) => {
                      console.log(err);
                  });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        },
        // 导出学生
        exportList() {
            let schoolId = sessionStorage.getItem('deptId');
            let schoolName = sessionStorage.getItem('deptName');
            axios.get(`${process.env.BASE_API}/api-teachingaffair/joinExamStudent/export/${schoolId}?schoolName=${schoolName}`, {
              headers: {
                authorization: 'bearer '+localStorage.getItem('Authorization')
              },
              responseType: 'blob'
            }).then(rs=>{
              let url = window.URL.createObjectURL(new Blob([rs.data]), {
                // type: "application/vnd.ms-excel"
                type: 'UTF-8'
              });
              // let link = document.createElement('a');
              // link.style.display = 'none';
              // link.href = url;
              // link.setAttribute('download', `${schoolName} - 考试已报名学生信息.xls`); // 自定义下载文件名（如exemple.txt）
              // document.body.appendChild(link);
              // link.click();

              this.$downloadFun(url, `${schoolName} - 考试已报名学生信息.xls`)
            })

            // this.$confirm('确定导出全部已报名考试的学生, 是否继续?', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     this.$ajax({
            //         url: `/api-teachingaffair/joinExamStudent/export/${schoolId}?schoolName=${schoolName}`,
            //         method: 'get',
            //         responseType: 'arraybuffer',
            //     }).then((data)=>{
            //         console.log(data);
            //         let url = window.URL.createObjectURL(new Blob([data.data],{type: "application/vnd.ms-excel"}));
            //         let link= document.createElement('a');
            //         link.style.display='none';
            //         link.href=url;
            //         link.setAttribute('download', `${schoolName} - 考试已报名学生信息.xls`);    // 自定义下载文件名（如exemple.txt）
            //         document.body.appendChild(link);
            //         link.click();
            //     });
            // }).catch(() => {
            //     this.$message({
            //         type: 'info',
            //         message: '已取消导出'
            //     });
            // });
        },
        goback() {
            this.$router.replace('/educa/testApply');
        },
        // 表格头部样式
        headerCellStyle({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0 && columnIndex == 2) {
                return "background:rgba(83,151,247,0.1);color:#999999; text-align:left !important; padding-left:20px !important;";
            } else if (rowIndex === 0 && columnIndex == 3) {
                return "background:rgba(83,151,247,0.1);color:#999999; text-align:left !important; padding-left:20px !important;";
            } else {
                return "background:rgba(83,151,247,0.1);color:#999999;";
            }
        },
        cellStyle(row, column, rowIndex, columnIndex) {
            if (row.columnIndex === 2 || row.columnIndex === 3) {
                return "text-align:left !important;padding-left:20px !important;";
            }
        },
        headerClassCellStyle({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0 && columnIndex == 1) {
                return "background:rgba(83,151,247,0.1);color:#999999; text-align:left !important; padding-left:20px !important;";
            } else {
                return "background:rgba(83,151,247,0.1);color:#999999;";
            }
        },
        cellClassStyle(row, column, rowIndex, columnIndex) {
            if (row.columnIndex === 1) {
                return "text-align:left !important;padding-left:20px !important;";
            }
        },
        handleCurrentChange(val) {//分页
          this.loading = true;
          this.pageTotal.currentPage = val;
          this.getStudentList()
        },
        handleSizeChange(val){//分页
          this.loading = true;
          this.pageTotal.pageSize = val;
          this.pageTotal.currentPage = 1;
          this.getStudentList()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        }
    }
};
</script>

<style lang="scss" scoped>
.cdjj-wrapper {
    padding: 0 16px;
    background: #fff;
    margin: 16px 16px 0;
    border-radius: 4px;
    .cdjj-header {
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #5397f7;
        .goback {
            padding: 0 10px;
            height: 26px;
            border: 1px solid #5397f7;
            border-radius: 4px;
            color: #5397f7;
            margin-right: 10px;
            .el-icon-d-arrow-left {
                color: #5397f7;
            }
        }
        h2 {
            display: inline-block;
            border-left: 2px solid #5397f7;
            color: #5397f7;
            font-size: 14px;
            padding-left: 4px;
            line-height: 10px;
            span {
                color: #262628;
                font-size: 12px;
                margin-left: 10px;
                strong {
                    color: #ff0000;
                }
            }
        }
        .btn {
            display: flex;
            align-items: center;
            .el-button {
                min-width: 72px;
                padding: 7px 11px;
                border-color: #5397f7;
                color: #5397f7;
                font-size: 12px;
                &:hover {
                    background: #5397f7;
                    color: #fff;
                }
            }
            .class-btn {
                padding: 8px 15px;
            }
            .el-select {
                width: 160px;
                margin-right: 10px;
            }
            .el-input {
                width: 220px;
                margin-right: 10px;
                /deep/ .el-input__inner {
                    height: 30px;
                    line-height: 30px;
                }
                /deep/ .el-input__suffix {
                    right: 0;
                }
                /deep/ .el-input__icon {
                    width: 40px;
                    line-height: 30px;
                    color: #fff;
                    background: #5397f7;
                    border-radius: 0px 4px 4px 0px;
                }
            }
        }
    }
    .cdjj-table {
        margin-top: 16px;
        .collegeTable {
            border: 1px solid #ebebeb;
            border-radius: 4px;
            border-bottom: 0;
        }
        /deep/ .el-table__empty-text {
            display: block;
            width: 200px;
            height: 200px;
            padding-top: 190px;
            color: #909399;
            box-sizing: border-box;
            background: url("../../../../../static/images/wujieguo.png") no-repeat;
        }
    }
    /deep/ .el-dialog__header {
        background: #edf4ff;
        border-radius: 8px 8px 0 0;
        height: 18px;
        &:before {
            width: 2px;
            height: 10px;
            background: rgba(83, 151, 247, 1);
            opacity: 1;
            border-radius: 4px;
        }
    }
    /deep/ .el-dialog__title {
        display: block;
        font-size: 14px;
        color: #5397f7;
        border-left: 2px solid #5397f7;
        padding-left: 5px;
        line-height: 10px;
    }
    /deep/ .el-dialog__footer {
        .el-button {
            width: 79px;
            height: 32px;
            line-height: 32px;
            padding: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/views/educationalAdmin/educationalAdminMenu/appliedList.vue